import { render, staticRenderFns } from "./parts-details.vue?vue&type=template&id=12dcdf60&scoped=true&"
import script from "./js/parts-details.js?vue&type=script&lang=js&"
export * from "./js/parts-details.js?vue&type=script&lang=js&"
import style0 from "./parts-details.vue?vue&type=style&index=0&id=12dcdf60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dcdf60",
  null
  
)

export default component.exports